'use client';
import { PageLayout } from '@xtnd/web/shared/layout';
import { MatterArDetailProvider } from '../components/common';
import Performance from '../components/reports/Performance';

export default function PerformancePage() {
  return (
    <PageLayout
      title="Performance"
      description="View performance metrics and analytics."
    >
      <MatterArDetailProvider>
        <Performance />
      </MatterArDetailProvider>
    </PageLayout>
  );
}
